<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-dialog">
    <div :class="{'overlay': true, 'visible': isVisible}">
      <div class="popup">
        <div class="popup-content">
          <h2 class="popup-title" v-if="title && title !=''">{{title}}</h2>
          <a class="close" @click="close">&times;</a>

          <div class="content" v-if="content && content !=''">
            <div v-html="content"/>
          </div>
        </div>
        <div class="popup-flex">
          <div class="remember-option" v-if="hasRememberOption&&controller&&showRememberOption">
            <el-checkbox class="checkbox" v-model="controller[rememberKey]"></el-checkbox>
            <div class="msg-content" @click="handleClickShowNextTime" >Don't show this message again</div>
          </div>
          <div class="button-section">
            <span class="popup-cancel-btn" @click="handleCancel">{{cancelButtonLabel}}</span>
            <button class="popup-discard-btn" v-if="discardButtonLabel" @click="handleDiscard">{{discardButtonLabel}}</button>
            <el-button v-if="this.from&&this.from==='wy-brands-configuration'" :class="(disableSaveBtn?'primary-btn confirm-btn disabled':'primary-btn confirm-btn')" :disabled="disableSaveBtn" @click="handleConfirm">{{confirmButtonLabel}}</el-button>
            <button v-else :class="(disableSaveBtn?'popup-confirm-btn disabled':'popup-confirm-btn')" :disabled="disableSaveBtn" @click="handleConfirm">{{confirmButtonLabel}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'wy-dialog',
  props: {
    cancelButtonLabel: {
      type: String,
      default: "Cancel"
    },

    discardButtonLabel: {
      type: String,
      default: null
    },

    confirmButtonLabel: {
      type: String,
      default: "Confirm"
    },

    controller: {
      type: Object,
      default: null
    },

    hasRememberOption: {
      type: Boolean,
      default: false
    },

    rememberKey: {
      type: String,
      default: "noShowNextTime"
    },

    from: {
      type: String,
      default: ""
    }
  },

  computed: {
    showRememberOption() {
      return !localStorage.getItem(this.rememberKey) || localStorage.getItem(this.rememberKey) == 'false'
    }
  },

  data() {
    return {
      module: this,
      isVisible: false,

      title: null,
      content: null,
      confirmButtonCallback: null,
      cancelButtonCallback: null,
      disableSaveBtn: false
    }
  },

  methods: {
    open() {
      this.isVisible = true;
    },

    close() {
      this.isVisible = false;
    },

    handleConfirm() {      
      if(this.confirmButtonCallback) {
        this.confirmButtonCallback();
      }
      this.close();
    },

    handleDiscard() {
      if(this.discardButtonCallback) {
        this.discardButtonCallback();
      }
      this.close();
    },

    handleCancel() {      
      if(this.cancelButtonCallback) {
        this.cancelButtonCallback();
      }
      this.close();
    },

    handleClickShowNextTime() {
      this.controller[this.rememberKey] = !this.controller[this.rememberKey]
    },

    
  }
}
</script>

<style lang="scss" scoped>
.wy-dialog {
  .popup-title {
    padding: 25px;
    border-bottom: var(--site-dialog-text-body-top-border);
  }
  .overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.1);
    transition: opacity 500ms;
    visibility: hidden;
    backdrop-filter: blur(2px);
    opacity: 0;
    z-index: 9999;
  }

  .overlay.visible {
    visibility: visible;
    opacity: 1;
  }

  .popup {
    box-shadow: var(--site-dialog-primary-shadow);
    margin: 70px auto;
    background: #fff;
    border-radius: 5px;
    position: relative;
    top: 108px;
    left: 142px;
    width: 672px;
    height: fit-content;
    transition: none !important;

    .popup-flex {
      display: flex;
      justify-content: flex-end;
      padding: 13px 19px;
      // border-top: 1px solid #CAD2E4;
      border-top: var(--site-dialog-text-body-top-border);
      width: 94.5%;

      .remember-option {
        margin-right: auto;
        font-size: 14.22px;
        display: flex;
        align-items: center;
        .checkbox {
          position: relative;
          span {
            color: #214586 !important;
          }
        }
        .msg-content {
          cursor: pointer;
          margin-left: 10px;
          color: var(--site-font-tertiary-color);
        }
        .el-checkbox.checkbox.is-checked+.msg-content {
          color: #214586;
        }
        // .el-checkbox__input.is-checked+.el-checkbox__label {
        //   color: red !important;
        // }
        // .el-checkbox.checkbox.is-checked {
        //   color: green; 
        //   .el-checkbox__label {
        //     color: red !important;
        //   }
        // }

        // .el-checkbox__input.is-checked+.el-checkbox__label {
        //   color: red !important;
        // }
      }
      // label.el-checkbox.is-checked {
      //   span.el-checkbox__label {
      //     color: #214586 !important;
      //   }
      // }
      
      .button-section {
        display: flex;
      }
    }
  }

  .popup h2 {
    margin-top: 30px;
    color: var(--site-font-tertiary-color);
    font-family: Helvetica Neue, Arial, sans-serif;
    font-size: 18px;
    font-weight: 500;
  }

  .popup .close {
    position: absolute;
    top: 8px;
    right: 18px;
    transition: none !important;
    font-size: 35px;
    font-weight: 400;
    text-decoration: none;
    color: var(--site-button-cancel-btn-primary-color);;
    cursor: pointer;
  }

  .popup .content {
    padding: 25px;
    margin-top: -16px;
    overflow: auto;
    color: var(--site-font-tertiary-color);
    font-family: Helvetica Neue, Arial, sans-serif;
    font-size: 14.22px;
    font-weight: 400;
  }

  .popup .popup-cancel-btn {
    color: var(--site-button-cancel-btn-primary-color) !important;
    font-family: Helvetica Neue, Arial, sans-serif;
    font-size: 15px;
    font-weight: 400;
    padding: 8px 16px 8px 16px;
    display: flex;
    border-radius: 5px;
    width: 64px;
    cursor: pointer;
    background: transparent;
    margin-right: 15px;
    align-items: center;
    justify-content: center;
    &:hover{
      // background: #F4F6F8;
    }
  }

  .popup .popup-discard-btn {
    width: 98px;
    height: 39px;
    padding: 8px 16px 8px 16px;
    font-size: 15px;
    cursor: pointer;
    background: transparent;
    color: var(--site-button-discard-btn-primary-color);
    border: 1px solid var(--site-button-cancel-btn-primary-border-color);
    margin-right: 15px;
    font-family: Helvetica Neue, Arial, sans-serif;
    border-radius: 5px;
  }
  .popup .primary-btn.confirm-btn {
    width: 98px;
    padding-bottom: 6px !important;
  }
  .popup .popup-confirm-btn {
    width: 98px;
    height: 39px;
    padding: 8px 16px 8px 16px;
    background: var(--site-button-primary-btn-background-primary-color);
    color: var(--site-button-primary-btn-text-primary-color) !important;
    border: 1px solid var(--site-button-primary-btn-hover-border-primary-color);
    font-size: 15px;
    cursor: pointer;
    font-family: Helvetica Neue, Arial, sans-serif;
    border-radius: 5px;
    &:hover{
      // background: #F4F6F8;
    }
  }
  .popup .popup-confirm-btn:hover {
    border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
    background-color: var(--site-button-primary-btn-hover-background-primary-color) !important;
    border-radius: 5px;
    color: var(--site-button-primary-btn-text-primary-color) !important;
  }
  .popup .popup-confirm-btn:active {
    background-color: var(--site-button-primary-btn-pressed-background-primary-color) !important;
  }
  .popup .popup-confirm-btn:focus {
    border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
    border-radius: 5px;
    color: var(--site-button-primary-btn-text-primary-color) !important;
  }

  .popup .popup-confirm-btn.disabled {
    color: var(--site-button-primary-btn-text-primary-color) !important;
    cursor: not-allowed;
  }
}
</style>

<style lang="scss">
//   .remember-option {
//     .checkbox {
//       span {
//         color: var(--site-font-tertiary-color);
//       }
//     }
//     .el-checkbox__input.is-checked+.el-checkbox__label {
//       color: #214586
//     }
//   }
</style>

